import React from 'react'
import { Typography } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import Link from '../Link'

interface PriceInsertProps {
  formattedAmount: string | undefined
  formattedDiscount?: string | null
  url?: string
  linkPriceClass: string
  originalPriceClass: string
}

export const ProductPriceInsert: React.FC<PriceInsertProps> = ({
  formattedAmount,
  formattedDiscount,
  url,
  linkPriceClass,
  originalPriceClass,
}) => {
  const { classes, cx } = useStyles()

  if (!formattedDiscount) {
    return (
      <Typography
        component={'span'}
        className={cx({
          [linkPriceClass]: true,
          [classes.linkPrice]: true,
        })}
      >
        <Link href={url}>{formattedAmount}</Link>
      </Typography>
    )
  }

  return (
    <>
      {formattedDiscount && (
        <Typography
          component={'span'}
          className={cx({
            [linkPriceClass]: true,
            [classes.linkPrice]: true,
          })}
        >
          <Link href={url}>{formattedDiscount}</Link>
        </Typography>
      )}
      <Typography
        component={'span'}
        className={cx({
          [originalPriceClass]: !!formattedDiscount,
          [classes.originalPrice]: true,
        })}
      >
        {formattedAmount}
      </Typography>
    </>
  )
}

const useStyles = makeStyles()((theme) => ({
  originalPrice: {
    '&&': {
      position: 'relative',
      color: theme.palette.secondary.dark,
      marginLeft: '0.75rem',
      bottom: '0.2rem',

      '&::after': {
        content: '""',
        display: 'block',
        backgroundColor: theme.palette.secondary.dark,
        width: '110%',
        position: 'absolute',
        top: '50%',
        left: '50%',
        height: '2px',
        marginLeft: '-55%',
      },

      [theme.breakpoints.down('md')]: {
        marginLeft: '0.5rem',
      },
    },
  },
  linkPrice: {
    '& a': {
      textDecoration: 'none',
      color: 'inherit',
      '&:active': {
        textDecoration: 'none',
        color: 'inherit',
      },
      '&:hover': {
        textDecoration: 'none',
        color: 'inherit',
      },
    },
  },
}))

export default ProductPriceInsert
